import { getUrlFromFileId } from '../utilities/formsUtilities';
const locationTypes = [
    { name: 'Circus', label: `Syrcas` },
    { name: 'CombinedArts', label: `Celfyddydau Cyfun` },
    { name: 'Comedy', label: `Comedi` },
    { name: 'CommunitySpace', label: `Man Cymunedol` },
    { name: 'Craft', label: `Crefftau` },
    { name: 'Dance', label: `Dawns` },
    { name: 'Festival', label: `G\u0175yl` },
    { name: 'Educational', label: `Addysgol` },
    { name: 'FamilyFriendly', label: `Ystyriol o Deuluoedd` },
    { name: 'FilmCinema', label: `Ffilmiau/Sinema` },
    { name: 'Gallery', label: `Oriel` },
    { name: 'ImmersiveAndVR', label: `Ymdrochol a realiti rhithwir` },
    { name: 'Library', label: `Llyfrgell` },
    { name: 'LiteraturePoetry', label: `Llenyddiaeth a Barddoniaeth` },
    { name: 'Museum', label: `Amgueddfa` },
    { name: 'Music', label: `Cerddoriaeth` },
    { name: 'Theatre', label: `Theatr` },
    { name: 'VisitorAttraction', label: `Atyniad i Ymwelwyr` },
    { name: 'VisualArt', label: `Celfyddydau Gweledol` }
];
const languages = [
    { name: 'en', label: 'English' },
    { name: 'cy', label: 'Cymraeg' },
    // {name: 'ga', label: 'Gaeilge'},
    { name: 'gd', label: 'Gaelic' }
];
const processLocationData = (_locationData) => {
    let locData, draftLocData, provisionData;
    let locationData = _locationData.location_data;
    if (!locationData) {
        return false;
    }
    locData = [
        { name: 'photo1', type: 'file', title: `Lleoliad`, value: locationData.photo1, required: true },
        { name: 'photo2', type: 'file', title: `Lleoliad`, value: locationData.photo2 },
        { name: 'photo3', type: 'file', title: `Lleoliad`, value: locationData.photo3 },
        { name: 'name', type: 'text', title: `Enw`, value: _locationData.name, 'required': true },
        { name: 'language', type: 'select', title: `Iaith`, value: locationData.language, options: languages },
        { name: 'address1', type: 'text', title: `Cyfeiriad y stryd`, value: locationData.address1, 'required': true },
        { name: 'address2', type: 'text', title: `Llinell 2 y cyfeiriad `, value: locationData.address2 },
        { name: 'city', type: 'text', title: `Dinas`, value: locationData.city, 'required': true },
        { name: 'country', type: 'text', title: `Gwlad`, value: locationData.country, 'required': true },
        { name: 'postcode', type: 'text', title: `Cod post`, value: locationData.postcode, 'required': true },
        { name: 'phone', type: 'text', title: `Ff\u00F4n`, value: locationData.phone },
        { name: 'email', type: 'email', title: `E-bost`, value: locationData.email },
        { name: 'website', type: 'url', title: `Gwefan`, value: locationData.website, 'required': true },
        { name: 'description', type: 'textarea', title: `Disgrifiad`, value: locationData.description, 'required': true },
        { name: 'type', type: 'multiselect', title: `Pa ffurfiau celfyddydol mae\u2019r lleoliad hwn yn eu cynnig?`, value: locationData.type, 'required': true, options: locationTypes },
        { name: 'accessInformation', type: 'url', title: `URL gwybodaeth am fynediad`, value: locationData.accessInformation },
        { name: 'videoUrl', type: 'url', title: `URL y daith ymgyfarwyddo`, value: locationData.videoUrl },
        { name: 'videoDescription', type: 'text', title: `Disgrifiad o\u2019r daith ymgyfarwyddo`, value: locationData.videoDescription, requiredIf: 'videoUrl' },
        { name: 'visualStory', type: 'url', title: `URL Stori Weledol`, value: locationData.visualStory },
        { name: 'accessAble', type: 'url', title: `URL AccessAble`, value: locationData.accessAble },
        { name: 'euansGuide', type: 'url', title: `URL Euan\u2019s Guide`, value: locationData.euansGuide },
        { name: 'acceptCeaCard', type: 'checkbox', title: `Derbyn Cerdyn CEA`, value: locationData.acceptCeaCard },
        { name: 'acceptNimbusCard', type: 'checkbox', title: `Derbyn Cerdyn Mynediad`, value: locationData.acceptNimbusCard },
        { name: 'acceptSunflowerLanyard', type: 'checkbox', title: `Derbyn Laniardiau Blodau\u2019r Haul`, value: locationData.acceptSunflowerLanyard },
        { name: 'allInScheme', type: 'checkbox', title: `Rhan o I Bawb`, value: locationData.allInScheme },
        { name: 'requiresProofOfEligibility', type: 'checkbox', title: `Angen prawf cymhwysedd`, value: locationData.requiresProofOfEligibility },
    ];
    provisionData = {};
    if (locationData.hasOwnProperty('draftInfo') && locationData.draftInfo && locationData.approvalStatus == 'AwaitingResponse') {
        if (typeof locationData.draftInfo === 'string') {
            locationData.draftInfo = JSON.parse(locationData.draftInfo);
        }
        let photo1 = {};
        if (locationData.draftInfo.photo1PublicUrl) {
            photo1 = { publicUrl: locationData.draftInfo.photo1PublicUrl };
        }
        else if (locationData.photo1 && locationData.photo1.id) {
            photo1 = locationData.photo1;
        }
        if (locationData.draftInfo.photo1AltText) {
            photo1.altText = locationData.draftInfo.photo1AltText;
        }
        let photo2 = {};
        if (locationData.draftInfo.photo2PublicUrl) {
            photo2 = { publicUrl: locationData.draftInfo.photo2PublicUrl };
        }
        else if (locationData.photo2 && locationData.photo2.id) {
            photo2 = locationData.photo2;
        }
        if (locationData.draftInfo.photo2AltText) {
            photo2.altText = locationData.draftInfo.photo2AltText;
        }
        let photo3 = {};
        if (locationData.draftInfo.photo3PublicUrl) {
            photo3 = { publicUrl: locationData.draftInfo.photo3PublicUrl };
        }
        else if (locationData.photo3 && locationData.photo3.id) {
            photo3 = locationData.photo3;
        }
        if (locationData.draftInfo.photo3AltText) {
            photo3.altText = locationData.draftInfo.photo3AltText;
        }
        draftLocData = [
            { name: 'photo1', type: 'file', title: `Lleoliad`, value: photo1, required: true },
            { name: 'photo2', type: 'file', title: `Lleoliad`, value: photo2 },
            { name: 'photo3', type: 'file', title: `Lleoliad`, value: photo3 },
            { name: 'name', type: 'text', title: `Enw`, value: locationData.draftInfo.name, 'required': true },
            { name: 'language', type: 'select', title: `Iaith`, value: locationData.draftInfo.language, options: languages },
            { name: 'address1', type: 'text', title: `Stryd`, value: locationData.draftInfo.address1, 'required': true },
            { name: 'address2', type: 'text', title: `Llinell 2 y cyfeiriad `, value: locationData.draftInfo.address2 },
            { name: 'city', type: 'text', title: `Dinas`, value: locationData.draftInfo.city, 'required': true },
            { name: 'country', type: 'text', title: `Gwlad`, value: locationData.draftInfo.country, 'required': true },
            { name: 'postcode', type: 'text', title: `Cod post`, value: locationData.draftInfo.postcode, 'required': true },
            { name: 'phone', type: 'text', title: `Ff\u00F4n`, value: locationData.draftInfo.phone },
            { name: 'email', type: 'email', title: `E-bost`, value: locationData.draftInfo.email },
            { name: 'website', type: 'url', title: `Gwefan`, value: locationData.draftInfo.website, 'required': true },
            { name: 'description', type: 'textarea', title: `Disgrifiad`, value: locationData.draftInfo.description, 'required': true },
            { name: 'type', type: 'multiselect', title: `Pa ffurfiau celfyddydol mae\u2019r lleoliad hwn yn eu cynnig?`, value: locationData.draftInfo.type, 'required': true, options: locationTypes },
            { name: 'accessInformation', type: 'url', title: `URL gwybodaeth am fynediad`, value: locationData.draftInfo.accessInformation },
            { name: 'videoUrl', type: 'url', title: `URL y daith ymgyfarwyddo`, value: locationData.draftInfo.videoUrl },
            { name: 'videoDescription', type: 'text', title: `Disgrifiad o\u2019r daith ymgyfarwyddo`, value: locationData.draftInfo.videoDescription, requiredIf: 'videoUrl' },
            { name: 'visualStory', type: 'url', title: `URL Stori Weledol`, value: locationData.draftInfo.visualStory },
            { name: 'accessAble', type: 'url', title: `URL AccessAble`, value: locationData.draftInfo.accessAble },
            { name: 'euansGuide', type: 'url', title: `URL Euan\u2019s Guide`, value: locationData.draftInfo.euansGuide },
            { name: 'acceptCeaCard', type: 'checkbox', title: `Derbyn Cerdyn CEA `, value: locationData.draftInfo.acceptCeaCard },
            { name: 'acceptNimbusCard', type: 'checkbox', title: `Derbyn Cerdyn Mynediad`, value: locationData.draftInfo.acceptNimbusCard },
            { name: 'acceptSunflowerLanyard', type: 'checkbox', title: `Derbyn Laniardiau Blodau\u2019r Haul`, value: locationData.draftInfo.acceptSunflowerLanyard },
            { name: 'allInScheme', type: 'checkbox', title: `Rhan o I Bawb`, value: locationData.draftInfo.allInScheme },
            { name: 'requiresProofOfEligibility', type: 'checkbox', title: `Angen prawf cymhwysedd`, value: locationData.draftInfo.requiresProofOfEligibility },
        ];
    }
    else {
        draftLocData = [];
    }
    if (_locationData.provisions) {
        provisionData = Object.entries(_locationData.provisions);
        provisionData = provisionData?.map((provision) => {
            provision = provision[1];
            provision.provisions = provision.provisions.map((item) => {
                if (item.hasOwnProperty('provision_data')) {
                    return {
                        name: item.standard?.name,
                        id: item.standard?.id,
                        image: item.provision_data.photo?.publicUrl,
                        imageId: item.provision_data.photo?.id,
                        alt: item.provision_data.photo?.altText,
                        description: item.provision_data?.description,
                        draft: item.provision_data?.draft,
                    };
                }
                else {
                    return {
                        name: item.name,
                        id: item.id,
                        image: item.image,
                        imageId: item.imageId,
                        alt: item.alt,
                        description: item.description,
                        draft: item.draft,
                    };
                }
            });
            return provision;
        });
    }
    return {
        locData: locData,
        draftLocData: draftLocData,
        provisionData: provisionData
    };
};
export { processLocationData, locationTypes };
